"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _dragdropcontext_definition = _interopRequireDefault(require("./dragdropcontext_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// https://github.com/atlassian/react-beautiful-dnd
// https://codesandbox.io/s/ql08j35j3q
// definition

/* ========== ~~~~~~~~~~ EXPORT : DRAGDROPCONTEXT ~~~~~~~~~~ ========== */


var IUIDragDropContext = function IUIDragDropContext(_ref) {
  var onDragEnd = _ref.onDragEnd,
      children = _ref.children;
  return _react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, children);
};
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(IUIDragDropContext, _dragdropcontext_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = IUIDragDropContext;
exports.default = _default;